import { useEffect } from 'react';

import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader({
  apiKey: window.env.REACT_APP_GOOGLE_MAPS_API,
  version: 'quarterly',
  libraries: ['places'],
});

export default function GoogleMapsLoader() {
  useEffect(() => {
    void loader.importLibrary('places');
  }, []);

  return null;
}
